import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

const books = [
  {
    author: "Mel Robins",
    title: "The Let Them Theory",
    img: "./images/book1.jpg",
    id: 1,
  },
  {
    author: "Richard Osman",
    title: "The Impossible Fortune",
    img: "https://images-eu.ssl-images-amazon.com/images/I/71sf-FKircL._AC_UL600_SR600,400_.jpg",
    id: 2,
  },
  {
    author: "Hale and Mighty",
    title: "Jaguar Rally Car",
    img: "https://www.petercarey.co.uk/jaguar/20190402_102048.jpg",
    id: 3,
  },
  {
    author: "Hale and Mighty",
    title: "A close-up of the Jaguar Rally Car",
    img: "https://www.petercarey.co.uk/jaguar/20190402_102224.jpg",
    id: 4,
  },
];

/* const BookList = () => {
    return (
      <section className="booklist"> */

const BookList = () => {
  return (
    <section className="booklist">
      <EventExamples />
      {books.map((book) => {
        return <Book {...book} key={book.id} />;
      })}
    </section>
  );
};

const EventExamples = () => {
    const handleFormInput = () => {
        console.log("handle form input");   
    };
    const handleButtonClick = () => {
       alert("handle button click");
     };
    return (
      <section>
        
          <form>
            <h2>Typical Form</h2>
            <input
              type="text"
              name="example"
              onChange = {handleFormInput}
              style={{ margin: "1rem 0" }}
            />
          </form>
          <button onClick = {handleButtonClick} >click me</button>
        </section>
    );
};
        
 const Book = ({img, title, author}) => {    
    // console.log(props);
    // const {img, title, author } = props;
    return (
        <article className="book">
        <img src={img} alt={title} />
        <h2>{title}</h2>
        <h4>{author}</h4>
       
       {/*   <Author /> 
        <p>{let x = 6}</p>  */}
      </article>
    );
};  

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<BookList />);